import * as marked from "marked";

/**
 * Setzt die Standardeinstellungen für die @see https://github.com/chjj/marked Library.
 */
export function initMarkdown(): void
{
    var renderer = new marked.Renderer();
    marked.setOptions({
        renderer: renderer,
        gfm: true,
        tables: true,
        breaks: true,
        pedantic: false,
        sanitize: true,
        smartLists: true,
        smartypants: false
    });

    renderer.paragraph = (text) =>
    {
        // User Mention Parsen.
        var mentions = text.match(/@(.[a-zA-Z]+)/g);
        if (mentions && mentions.length > 0) 
        {
            for (var mention of mentions)
            {
                text = text.replace(mention, `<a>${mention}</a>`);
            }
        }

        return '<p>' + text + '</p>\n';
    };
}